import { Card, Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import CollectionDataTable from "../../../../ui/components/CollectionDataTable/CollectionDataTable";
import useUsersQuery from "../../../../users/hooks/useUsersQuery";

import usePublisherUsersTableColumns from "../hooks/usePublisherUsersTableColumns";

export default function PublisherUsers({ publisher }) {
	const { t } = useTranslation();

	const usersQuery = useUsersQuery({ organization: publisher });
	const usersColumns = usePublisherUsersTableColumns(publisher);

	return (
		<>
			<Header as="h3">{t("publisherUsers", "Publisher users")}</Header>

			<Card fluid>
				<Card.Content>
					<CollectionDataTable
						query={usersQuery}
						columns={usersColumns}
						sortBy={{
							id: "name",
							desc: false,
						}}
					/>
				</Card.Content>
			</Card>
		</>
	);
}
